<div
  class="layout-sidebar"
  (mouseenter)="onMouseEnter()"
  (mouseleave)="onMouseLeave()"
>
  <div *ngIf="layoutService.state.sidebarActive" class="sidebar-header pt-0">
    <img src="assets/img/nube_cc_200x140.png" alt="logo" />
  </div>

  <div #menuContainer class="layout-menu-container">
    <app-menu></app-menu>
  </div>

  <div class="flex flex-column pl-5 pb-3 text-left">
    <div>
      <span
        ngClass="{{
          currentLang === 'es_ES' ? 'text-600 font-bold' : 'text-400 cursor-pointer'
        }}"
        (click)="changeCurrentLang('es_ES')"
      >
        ES</span
      >
      |
      <span
        ngClass="{{
          currentLang === 'en_US' ? 'text-600 font-bold' : 'text-400 cursor-pointer'
        }}"
        (click)="changeCurrentLang('en_US')"
        >EN</span
      >
    </div>
    <span class="text-400 font-bold text-xs">&#64;Nousmedis 2021-2025</span>
  </div>
</div>
